import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppText, Box, styled } from '@streem/ui-react';
import { useRoomSession } from '../../../context/room_session';
import { useObservable } from '../../../hooks/rxjs';
export const LegacyInCallCustomerDetails = () => {
    const roomSession = useRoomSession();
    const [room] = useObservable(roomSession?.room.room);
    if (!room?.details?.length)
        return null;
    return (_jsx(DetailsSection, { children: room?.details?.map(section => {
            return (_jsxs(SectionContainer, { children: [_jsx(AppText, { as: "h6", headingFontFamily: true, semibold: true, "data-testId": `${section.label}-label`, children: section.label }), _jsx(AppText, { "data-testId": `${section.label}-value`, children: section.value })] }, section.label));
        }) }));
};
const DetailsSection = styled(Box)(({ theme }) => ({
    marginTop: '20px',
    padding: '16px',
    border: `solid 1px ${theme.colors.grey10}`,
    borderRadius: '10px',
}));
const SectionContainer = styled(Box)({
    ':not(:last-of-type)': {
        marginBottom: '24px',
    },
});
//# sourceMappingURL=legacy_in_call_customer_details.js.map